import { MARKETING } from 'modules/billing/constants';
import {
  isOrgGlobalWhatsAppCountryMarketingMetric,
  isOrgGlobalWhatsAppCountryUtilityMetric,
  isOrgLevelWhatsAppMarketingMetric,
  isOrgLevelWhatsAppUtilityMetric,
} from 'modules/billing/utils';
import { useBillingQueryContext } from '../../../contexts';
import { AnalyticCard } from '../AnalyticCard';
import { AnalyticTable, TableMetric } from '../AnalyticTable';
import { GLOBAL_WHATSAPP_CARD_IDS, GLOBAL_WHATSAPP_CARD_TEXT } from './constants';

export const GlobalWhatsAppCard = () => {
  const { displayDateRange, pickOrgMetrics, pickOrgValue, isLoading } = useBillingQueryContext();

  const whatsAppUtilityValue = pickOrgValue('WhatsAppSent', isOrgLevelWhatsAppUtilityMetric);
  const whatsAppMarketingValue = pickOrgValue('WhatsAppSent', isOrgLevelWhatsAppMarketingMetric);
  const utilityCountryMetrics = pickOrgMetrics(
    'WhatsAppSent',
    isOrgGlobalWhatsAppCountryUtilityMetric,
  );
  const marketingCountryMetrics = pickOrgMetrics(
    'WhatsAppSent',
    isOrgGlobalWhatsAppCountryMarketingMetric,
  );

  const cardMetrics = [
    {
      metricName: GLOBAL_WHATSAPP_CARD_TEXT.utilityMessagesName,
      metricValue: whatsAppUtilityValue,
      timePeriod: displayDateRange,
    },
    {
      metricName: GLOBAL_WHATSAPP_CARD_TEXT.marketingMessagesName,
      metricValue: whatsAppMarketingValue,
      timePeriod: displayDateRange,
    },
  ];

  const columns = [
    { label: 'By Country' },
    { isNumeric: true, label: 'Utility' },
    { isNumeric: true, label: 'Marketing' },
  ];

  const tableMetricObj = [...utilityCountryMetrics, ...marketingCountryMetrics].reduce(
    (acc, curr) => {
      const countryVal = acc[curr.recipientCountryName as string] || [{ value: 0 }, { value: 0 }];
      if (curr.templateCategory === MARKETING) {
        countryVal[1].value = curr.value;
      } else {
        countryVal[0].value = curr.value;
      }
      return { ...acc, [curr.recipientCountryName as string]: countryVal };
    },
    {} as any,
  );

  const tableMetricArray = Object.keys(tableMetricObj)
    .reduce((acc, curr) => {
      return [
        ...acc,
        {
          metricName: { label: curr },
          values: tableMetricObj[curr],
        },
      ];
    }, [] as TableMetric[])
    .sort(
      (a, b) => b.values[0].value + b.values[1].value - (a.values[0].value + a.values[1].value),
    );

  const maxRows = 5;
  const topWhatsAppRows = tableMetricArray.slice(0, maxRows);
  const additionalWhatsAppMetrics = tableMetricArray.slice(maxRows);

  const additionalWhatsAppSums = additionalWhatsAppMetrics.reduce(
    (acc, curr) => {
      return [acc[0] + curr.values[0].value, acc[1] + curr.values[1].value];
    },
    [0, 0],
  );

  const sumMetric = {
    metricName: { label: 'All other countries' },
    values: [
      { isTotal: true, value: additionalWhatsAppSums[0] as number },
      { isTotal: true, value: additionalWhatsAppSums[1] as number },
    ],
  };

  const tableMetricsWithSum =
    tableMetricArray.length > maxRows ? [...topWhatsAppRows, sumMetric] : tableMetricArray;

  return (
    <AnalyticCard
      //   CardAction={<GlobalSmsExportProjectUsageButton />}
      data-test={GLOBAL_WHATSAPP_CARD_IDS.cardId}
      isLoading={isLoading}
      metrics={cardMetrics}
      title={GLOBAL_WHATSAPP_CARD_TEXT.cardTitle}
    >
      <AnalyticTable columns={columns} gridLayout="1fr 160px 160px" metrics={tableMetricsWithSum} />
    </AnalyticCard>
  );
};
